import request from '@/utils/http';

const urlBase = '/api-srm-web/supplier';

// 查询供应商信息
export const getSupplierInfo = (params) => {
    return request({
        url: `${urlBase}/querySupplierInfoByUserCode/${params}`,
        method: 'get'
    });
};

// 查询供应商详情
export const getSupplierDetail = (params) => {
    return request({
        url: `${urlBase}/platform/showPlatformSupplierDetail`,
        method: 'get',
        params
    });
};

// 保存供应商详情
export const saveSupplierDetail = (params) => {
    return request({
        url: `${urlBase}/platform/saveSupplierDetail`,
        method: 'post',
        data: params
    });
};

// 提交供应商详情
export const commitSupplierDetail = (params) => {
    return request({
        url: `${urlBase}/platform/commitSupplierDetail`,
        // method: 'post',
        method: 'put',
        params: params
    });
};